import React, { useEffect, useState } from 'react'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import apiService from '../../services/apiServices';
import { useForm } from 'react-hook-form';

const EmployeeCardPdf = ({ employeeCard }) => {
    const months = [
        { no: 1, name: 'Janar' },
        { no: 2, name: 'Shkurt' },
        { no: 3, name: 'Mars' },
        { no: 4, name: 'Prill' },
        { no: 5, name: 'Maj' },
        { no: 6, name: 'Qershor' },
        { no: 7, name: 'Korrik' },
        { no: 8, name: 'Gusht' },
        { no: 9, name: 'Shtator' },
        { no: 10, name: 'Tetor' },
        { no: 11, name: 'Nentor' },
        { no: 12, name: 'Dhjetor' }
    ]

    const {
        setValue,
        watch,
    } = useForm();


    const getCompanyData = () => {
        apiService().get("settings").then(response => {
            const fields = Object.keys(response.data[0]);
            fields.map((field) =>
                setValue(field, response.data[0][field])
            );
        })
    }

    const calculateColumnTotal = (data, property) => {
        return parseFloat(data?.reduce((accumulator, current) => parseFloat(accumulator) + parseFloat(current[property]), 0)).toFixed(2)
    }

    useEffect(() => {
        getCompanyData();
    }, [])



    return (
        <div id="contentTable">
            <Table stickyHeader aria-label="sticky table">
                <TableBody>
                    <TableRow>
                        <TableCell style={{borderBottom: 0}}>
                            <img style={{ width: "100px" }} alt='' src={watch("Logo")} />
                        </TableCell>
                        <TableCell style={{ padding: "0px !important" }}>
                            <ul className='emp-card-company' style={{ listStyle: 'none' }}>
                                <li style={{ borderBottom: '1px solid rgba(224, 224, 224, 1)' }}>Emri i kompanisë: {watch("CompanyName")}</li>
                                <li>NUI: {watch("NUI")}</li>
                                <li>Adresa: {watch("Address")}</li>
                                <li>Qyteti: {watch("City")}</li>
                            </ul>
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
            <Table style={{marginTop: 50}}>
                <TableRow>
                    <TableCell colSpan={2} style={{ textAlign: 'center', fontSize: '25px', fontWeight: 'bold' }}>Kartela e punëtorit</TableCell>
                </TableRow>
            </Table>
            <Table stickyHeader aria-label="sticky table">
                <TableBody>
                    <TableRow>
                        <TableCell>Emri dhe mbiemri </TableCell>
                        <TableCell>{employeeCard?.FirstName} {employeeCard?.LastName}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>ID: </TableCell>
                        <TableCell>{employeeCard?.PersonalId}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Adresa: </TableCell>
                        <TableCell>{employeeCard?.Address}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Filiali: </TableCell>
                        <TableCell>{employeeCard?.Branch}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Departamenti: </TableCell>
                        <TableCell>{employeeCard?.Department}</TableCell>
                    </TableRow>
                </TableBody>
            </Table>
            <Table>
                <TableBody>
                    <TableRow>
                        <TableCell>Pushimi i lejuar vjetor: </TableCell>
                        <TableCell>{employeeCard?.allHolidays}</TableCell>
                        <TableCell>Shfrytëzuar: </TableCell>
                        <TableCell>{employeeCard?.days}</TableCell>
                        <TableCell>pashfrytëzuar: </TableCell>
                        <TableCell>{employeeCard?.allHolidays - employeeCard?.days}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Pushimie me pagesë: </TableCell>
                        <TableCell>{employeeCard?.holidaysWithPay}</TableCell>
                        <TableCell>Shfrytëzuar: </TableCell>
                        <TableCell>{employeeCard?.holidaysWithPay}</TableCell>
                        <TableCell>pashfrytëzuar: </TableCell>
                        <TableCell>{employeeCard?.allHolidays - employeeCard?.days}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Pushime pa pagesë: </TableCell>
                        <TableCell>{employeeCard?.holidaysWithoutPay}</TableCell>
                        <TableCell>Shfrytëzuar: </TableCell>
                        <TableCell>0</TableCell>
                        <TableCell>pashfrytëzuar: </TableCell>
                        <TableCell>0</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Pushim mjeksor: </TableCell>
                        <TableCell>{employeeCard?.medicalHoliday}</TableCell>
                        <TableCell>Shfrytëzuar: </TableCell>
                        <TableCell>{employeeCard?.medicalHoliday}</TableCell>
                        <TableCell>pashfrytëzuar: </TableCell>
                        <TableCell>0</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Pushime martesor: </TableCell>
                        <TableCell>{employeeCard?.martialHoliday}</TableCell>
                        <TableCell>Shfrytëzuar: </TableCell>
                        <TableCell>{employeeCard?.martialHoliday}</TableCell>
                        <TableCell>pashfrytëzuar: </TableCell>
                        <TableCell>0</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Pushime i jashtzakonshem: </TableCell>
                        <TableCell>{employeeCard?.otherHoliday}</TableCell>
                        <TableCell>Shfrytëzuar: </TableCell>
                        <TableCell>{employeeCard?.otherHoliday}</TableCell>
                        <TableCell>pashfrytëzuar: </TableCell>
                        <TableCell>0</TableCell>
                    </TableRow>
                </TableBody>
            </Table>
            <Table>
                <TableBody>
                    <TableRow className="tr-head" style={{ background: "#9e9e9e7d" }}>
                        <TableCell>Muaji</TableCell>
                        <TableCell>Paga Bruto</TableCell>
                        <TableCell>Kontributi nga punëtori</TableCell>
                        <TableCell>Kontributi nga punëdhënësi</TableCell>
                        <TableCell>Kontributet</TableCell>
                        <TableCell>Taksat</TableCell>
                        <TableCell>Paga neto</TableCell>
                        <TableCell>Shpërblimet</TableCell>
                        <TableCell>Totali</TableCell>
                    </TableRow>
                    {console.log(employeeCard)}
                    {employeeCard?.salaries?.map((salary, index) => (
                        <TableRow>
                            <TableCell>
                                {months.find(m => m.no === salary.Month).name}
                            </TableCell>
                            <TableCell>
                                {parseFloat(salary?.Salary).toFixed(2)}
                            </TableCell>
                            <TableCell>{parseFloat(salary?.employeeTaxFee).toFixed(2)}</TableCell>
                            <TableCell>{parseFloat(salary?.employerTaxFee).toFixed(2)}</TableCell>
                            <TableCell>{parseFloat(salary?.contributions).toFixed(2)}</TableCell>
                            <TableCell>{parseFloat(salary?.taxes).toFixed(2)}</TableCell>
                            <TableCell>{parseFloat(salary?.neto).toFixed(2)}</TableCell>
                            <TableCell>{parseFloat(salary?.Bonus).toFixed(2)}</TableCell>
                            <TableCell>{parseFloat(salary?.total).toFixed(2)}</TableCell>
                        </TableRow>
                    ))}
                    <TableRow style={{ background: "#9e9e9e7d" }}>
                        <TableCell>Totali:</TableCell>
                        <TableCell>{calculateColumnTotal(employeeCard?.salaries, "Salary")}</TableCell>
                        <TableCell>{calculateColumnTotal(employeeCard?.salaries, "employeeTaxFee")}</TableCell>
                        <TableCell>{calculateColumnTotal(employeeCard?.salaries, "employerTaxFee")}</TableCell>
                        <TableCell>{calculateColumnTotal(employeeCard?.salaries, "contributions")}</TableCell>
                        <TableCell>{calculateColumnTotal(employeeCard?.salaries, "taxes")}</TableCell>
                        <TableCell>{calculateColumnTotal(employeeCard?.salaries, "neto")}</TableCell>
                        <TableCell>{calculateColumnTotal(employeeCard?.salaries, "Bonus")}</TableCell>
                        <TableCell>{calculateColumnTotal(employeeCard?.salaries, "total")}</TableCell>
                    </TableRow>

                </TableBody>
            </Table>
        </div>
    )
}

export default EmployeeCardPdf